import { Component, Inject, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { ComponentFactoryService } from '../../../../../../services/component-factory.service';
import { BeneficiosTributariosDescuentosModalComponent } from '../../beneficios-tributarios/beneficios-tributarios-descuentos/beneficios-tributarios-descuentos-modal.component';
import { IngresosAsalariadooServidorpublicoModalComponent } from '../ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { IngresostrabajadorindependienteModalComponent } from '../ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';
import { BeneficiosIngresosNoGravados } from '../../beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';

const VAL_INDICADOR_COMPLETO = "999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE = 'cs_id_228';

const stepsList = [
  { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Muebles Leasing', listHelp: ['507'] }
];
const tableStructure = [
  { id: 'textoUbicacionDelBien', title: 'Ubicacion del bien' },
  { id: 'valorVenta', title: 'Valor venta' },
  { id: 'costoFiscal', title: 'Costo fiscal' },
];

class ArticulosDominio {
  valor: number;
  nombre: string;
}

class Form1 {
  id: number;
  ubicacionDelBien: string;
  textoUbicacionDelBien: string;
  anioDeCompra: string;
  valorDeCompra: string;
  anioAnteriorAplicoReajusteArt73: string;
  valorDeclaradoAnioAnterior: string;
  valorVenta: string;
  mejoras: string;
  avaluoCatastralAnioAnterior: string;
  costoFiscal: string;
  cumpleConLoSenaladoEnArt311: string;
  retencionOImpuestoExterior: string;
  //casillas ocultas
  resultadoArt73MasMejoras: string;
  avaluoCatastralMasMejoras: string;
  valorDeclaradoAnioAnteriorMasMejoras: string;
  valorDeCompraMasMejoras: string;
  utilidad: string;
  articulo44: string;
  articulo311: string;
}
@Component({
  selector: 'app-ingresos-venta-vivienda-modal',
  templateUrl: './ingresos-venta-vivienda-modal.component.html',
  styleUrls: ['./ingresos-venta-vivienda-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    ComponentFactoryService
  ]
})
export class IngresosVentaViviendaModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstSiNo: ArticulosDominio[] = [];
  public lstUbicacionVivienda: ArticulosDominio[] = [];
  public lstArticulos: ArticulosDominio[] = [];
  public lstCostoFiscal: ArticulosDominio[] = [];
  public lstAnios: number[] = [];

  public OPERACION_NULA: number = 0;
  public OPERACION_AGREGAR: number = 1;
  public OPERACION_EDITAR: number = 2;
  public OPERACION_BORRAR: number = 3;
  public operacionTabla: number = this.OPERACION_NULA;
  mensajeTabla = "Agregue, edite o elimine sus ingresos según su realidad económica.";

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave: boolean;
  tablaArt73: any;
  tablaArt44: any; 
  valorUVT: any;
  resultadoArticulo73: string;
  selectCostoFiscal: number;
  constructor(
    public dialogRef: MatDialogRef<IngresosVentaViviendaModalComponent>,
    public dutilidades: DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    private _componentFactory: ComponentFactoryService,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
this.tablaArt44= {
  '1986': 0.10,
  '1985': 0.20,
  '1984': 0.30,
  '1983': 0.40,
  '1982': 0.50,
  '1981': 0.60,
  '1980': 0.70,
  '1979': 0.80,
  '1978': 0.90,
  '1977': 1.00
};
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();

    /*  this.validateBtnRightActive();
    this.validateShowSave(); */
    this.initializeAnios();
    console.log(this.model);

  }

  protected inicializeForm() {
    this.modelForm = new Form1();
    this.modelForm.id = 0;
    this.modelForm.ubicacionDelBien = "1"
    this.modelForm.textoUbicacionDelBien = "Vivienda Colombia"
    this.modelForm.anioDeCompra = ""
    this.modelForm.valorDeCompra = "0"
    this.modelForm.anioAnteriorAplicoReajusteArt73 = "0"
    this.modelForm.valorDeclaradoAnioAnterior = "0"
    this.modelForm.valorVenta = "0"
    this.modelForm.mejoras = "0"
    this.modelForm.avaluoCatastralAnioAnterior = "0"
    this.modelForm.costoFiscal = "0"
    this.modelForm.cumpleConLoSenaladoEnArt311 = "0"
    this.modelForm.retencionOImpuestoExterior = "0"
    //casillas ocultas
    this.modelForm.resultadoArt73MasMejoras = "0"
    this.modelForm.avaluoCatastralMasMejoras = "0"
    this.modelForm.valorDeclaradoAnioAnteriorMasMejoras = "0"
    this.modelForm.valorDeCompraMasMejoras = "0"
    this.modelForm.utilidad = "0"
    this.modelForm.articulo44 = "0"
    this.modelForm.articulo311 = "0"
    this.reloadSelArticulos();
  }


  protected inicializeModelo() {
    if (this.model.doc.cuerpo.cc_id_508 == undefined) {

      this.model.doc.cuerpo.cc_id_508 = [];
      this.model.doc.cuerpo.cs_id_509 = '0';
      this.model.doc.cuerpo.cc_id_509 = [];
      this.model.doc.cuerpo.cc_id_510 = [];
      this.model.doc.cuerpo.cc_id_514 = [];
      this.model.doc.cuerpo.cc_id_515 = [];
      this.model.doc.cuerpo.cc_id_516 = [];
      this.model.doc.cuerpo.cc_id_517 = [];
      this.model.doc.cuerpo.cc_id_518 = [];
      this.model.doc.cuerpo.cc_id_519 = [];
      this.model.doc.cuerpo.cc_id_520 = [];
      this.model.doc.cuerpo.cc_id_521 = [];
      this.model.doc.cuerpo.cc_id_522 = [];
      this.model.doc.cuerpo.cc_id_523 = [];
      this.model.doc.cuerpo.cc_id_524 = [];
      this.model.doc.cuerpo.cc_id_525 = [];
      this.model.doc.cuerpo.cc_id_526 = [];
      this.model.doc.cuerpo.cc_id_527 = [];
      this.model.doc.cuerpo.cc_id_528 = [];

    }
  }

  protected reloadSelArticulos(conservarArt?: boolean) {//Dom 1649


    this.lstSiNo[0] = { valor: 0, nombre: "No" };
    this.lstSiNo[1] = { valor: 1, nombre: "Si" };

    this.lstUbicacionVivienda[0] = { valor: 1, nombre: "Vivienda Colombia" };
    this.lstUbicacionVivienda[1] = { valor: 2, nombre: "Vivienda exterior" };
    
    const mejoras=Number(this.dutilidades.deshacerFormatoMoneda(this.modelForm.mejoras));
    this.lstCostoFiscal=[];
if (this.modelForm.anioAnteriorAplicoReajusteArt73=='1') {
      this.lstCostoFiscal[0] = { valor: 0, nombre: "Resultado Art 73 " + ((mejoras > 0) ? "+ mejoras: " : ": ") + this.modelForm.resultadoArt73MasMejoras };
      this.lstCostoFiscal[1] = { valor: 1, nombre: "Avaluó catastral " + ((mejoras > 0) ? "+ mejoras: " : ": ") + this.modelForm.avaluoCatastralMasMejoras };
      this.lstCostoFiscal[2] = { valor: 2, nombre: "Valor declarado año anterior " + ((mejoras > 0) ? "+ mejoras: " : ": ") + this.modelForm.valorDeclaradoAnioAnteriorMasMejoras };
      this.lstCostoFiscal[3] = { valor: 3, nombre: "Valor de compra " + ((mejoras > 0) ? "+ mejoras: " : ": ") + this.modelForm.valorDeCompraMasMejoras };
  
}else{
  this.lstCostoFiscal[0] = { valor: 1, nombre: "Avaluó catastral " + ((mejoras > 0) ? "+ mejoras: " : ": ") + this.modelForm.avaluoCatastralMasMejoras };
  this.lstCostoFiscal[1] = { valor: 2, nombre: "Valor declarado año anterior " + ((mejoras > 0) ? "+ mejoras: " : ": ") + this.modelForm.valorDeclaradoAnioAnteriorMasMejoras };
  this.lstCostoFiscal[2] = { valor: 3, nombre: "Valor de compra " + ((mejoras > 0) ? "+ mejoras: " : ": ") + this.modelForm.valorDeCompraMasMejoras };

}
    // if (!conservarArt) this.modelForm.art = 0;

  }
  protected initializeAnios() {
    /*  for(let i=0; i<this.tablaArt73.length;i++){ 
     this.lstAnios[i]=Number(this.tablaArt73[i].anio);*/
    this.lstAnios = this.tablaArt73
      .filter(item => item.anioGravable === "2023")
      .map(item => item.anio);

    // }

  }

  protected initializeTablaDesdeModelo() {
    this.dataSourceBody = [];
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_508.length; i++) {
      this.modelForm.id = i;


      this.modelForm.textoUbicacionDelBien = this.lstUbicacionVivienda.find(item => item.valor == Number(this.model.doc.cuerpo.cc_id_508[i].v)).nombre;

      this.modelForm.ubicacionDelBien = this.model.doc.cuerpo.cc_id_508[i].v;
      this.modelForm.valorVenta = this.model.doc.cuerpo.cc_id_509[i].v;
      this.modelForm.costoFiscal = this.model.doc.cuerpo.cc_id_510[i].v;
      this.modelForm.anioDeCompra = this.model.doc.cuerpo.cc_id_514[i].v;
      this.modelForm.valorDeCompra = this.model.doc.cuerpo.cc_id_515[i].v;
      this.modelForm.anioAnteriorAplicoReajusteArt73 = this.model.doc.cuerpo.cc_id_516[i].v;
      this.modelForm.valorDeclaradoAnioAnterior = this.model.doc.cuerpo.cc_id_517[i].v;
      this.modelForm.mejoras = this.model.doc.cuerpo.cc_id_518[i].v;
      this.modelForm.avaluoCatastralAnioAnterior = this.model.doc.cuerpo.cc_id_519[i].v;
      this.modelForm.cumpleConLoSenaladoEnArt311 = this.model.doc.cuerpo.cc_id_520[i].v;
      this.modelForm.retencionOImpuestoExterior = this.model.doc.cuerpo.cc_id_521[i].v;
      this.modelForm.utilidad = this.model.doc.cuerpo.cc_id_522[i].v;
      this.modelForm.articulo44 = this.model.doc.cuerpo.cc_id_523[i].v;
      this.modelForm.articulo311 = this.model.doc.cuerpo.cc_id_524[i].v;
      this.modelForm.resultadoArt73MasMejoras = this.model.doc.cuerpo.cc_id_525[i].v;
      this.modelForm.avaluoCatastralMasMejoras = this.model.doc.cuerpo.cc_id_526[i].v;
      this.modelForm.valorDeclaradoAnioAnteriorMasMejoras = this.model.doc.cuerpo.cc_id_527[i].v;
      this.modelForm.valorDeCompraMasMejoras = this.model.doc.cuerpo.cc_id_528[i].v;


      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }
  public editModeloDesdeForm() {

    this.model.doc.cuerpo.cc_id_508[this.modelForm.id].v = this.modelForm.ubicacionDelBien;
    this.model.doc.cuerpo.cc_id_509[this.modelForm.id].v = this.modelForm.valorVenta;
    this.model.doc.cuerpo.cc_id_510[this.modelForm.id].v = this.modelForm.costoFiscal;
    this.model.doc.cuerpo.cc_id_514[this.modelForm.id].v = this.modelForm.anioDeCompra;
    this.model.doc.cuerpo.cc_id_515[this.modelForm.id].v = this.modelForm.valorDeCompra;
    this.model.doc.cuerpo.cc_id_516[this.modelForm.id].v = this.modelForm.anioAnteriorAplicoReajusteArt73;
    this.model.doc.cuerpo.cc_id_517[this.modelForm.id].v = this.modelForm.valorDeclaradoAnioAnterior;
    this.model.doc.cuerpo.cc_id_518[this.modelForm.id].v = this.modelForm.mejoras;
    this.model.doc.cuerpo.cc_id_519[this.modelForm.id].v = this.modelForm.avaluoCatastralAnioAnterior;
    this.model.doc.cuerpo.cc_id_520[this.modelForm.id].v = this.modelForm.cumpleConLoSenaladoEnArt311;
    this.model.doc.cuerpo.cc_id_521[this.modelForm.id].v = this.modelForm.retencionOImpuestoExterior;
    this.model.doc.cuerpo.cc_id_522[this.modelForm.id].v = this.modelForm.utilidad;
    this.model.doc.cuerpo.cc_id_523[this.modelForm.id].v = this.modelForm.articulo44;
    this.model.doc.cuerpo.cc_id_524[this.modelForm.id].v = this.modelForm.articulo311;
    this.model.doc.cuerpo.cc_id_525[this.modelForm.id].v = this.modelForm.resultadoArt73MasMejoras;
    this.model.doc.cuerpo.cc_id_526[this.modelForm.id].v = this.modelForm.avaluoCatastralMasMejoras;
    this.model.doc.cuerpo.cc_id_527[this.modelForm.id].v = this.modelForm.valorDeclaradoAnioAnteriorMasMejoras;
    this.model.doc.cuerpo.cc_id_528[this.modelForm.id].v = this.modelForm.valorDeCompraMasMejoras;


  }
  public addToModeloDesdeForm() {
    let i = this.modelForm.id + 1;

    this.model.doc.cuerpo.cc_id_508.push({ it: i, v: this.modelForm.ubicacionDelBien });
    this.model.doc.cuerpo.cc_id_509.push({ it: i, v: this.modelForm.valorVenta });
    this.model.doc.cuerpo.cc_id_510.push({ it: i, v: this.modelForm.costoFiscal });
    this.model.doc.cuerpo.cc_id_514.push({ it: i, v: this.modelForm.anioDeCompra });
    this.model.doc.cuerpo.cc_id_515.push({ it: i, v: this.modelForm.valorDeCompra });
    this.model.doc.cuerpo.cc_id_516.push({ it: i, v: this.modelForm.anioAnteriorAplicoReajusteArt73 });
    this.model.doc.cuerpo.cc_id_517.push({ it: i, v: this.modelForm.valorDeclaradoAnioAnterior });
    this.model.doc.cuerpo.cc_id_518.push({ it: i, v: this.modelForm.mejoras });
    this.model.doc.cuerpo.cc_id_519.push({ it: i, v: this.modelForm.avaluoCatastralAnioAnterior });
    this.model.doc.cuerpo.cc_id_520.push({ it: i, v: this.modelForm.cumpleConLoSenaladoEnArt311 });
    this.model.doc.cuerpo.cc_id_521.push({ it: i, v: this.modelForm.retencionOImpuestoExterior });
    this.model.doc.cuerpo.cc_id_522.push({ it: i, v: this.modelForm.utilidad });
    this.model.doc.cuerpo.cc_id_523.push({ it: i, v: this.modelForm.articulo44 });
    this.model.doc.cuerpo.cc_id_524.push({ it: i, v: this.modelForm.articulo311 });
    this.model.doc.cuerpo.cc_id_525.push({ it: i, v: this.modelForm.resultadoArt73MasMejoras });
    this.model.doc.cuerpo.cc_id_526.push({ it: i, v: this.modelForm.avaluoCatastralMasMejoras });
    this.model.doc.cuerpo.cc_id_527.push({ it: i, v: this.modelForm.valorDeclaradoAnioAnteriorMasMejoras });
    this.model.doc.cuerpo.cc_id_528.push({ it: i, v: this.modelForm.valorDeCompraMasMejoras });
    // if (this.model.doc.cuerpo.cc_id_509.length>0) {
    //   this.model.doc.cuerpo.cc_id_509=[];
    // }


  }

  public deleteOnModel(index: number) {

    this.model.doc.cuerpo.cc_id_508.splice(index, 1);
    this.model.doc.cuerpo.cc_id_509.splice(index, 1);
    this.model.doc.cuerpo.cc_id_510.splice(index, 1);
    this.model.doc.cuerpo.cc_id_514.splice(index, 1);
    this.model.doc.cuerpo.cc_id_515.splice(index, 1);
    this.model.doc.cuerpo.cc_id_516.splice(index, 1);
    this.model.doc.cuerpo.cc_id_517.splice(index, 1);
    this.model.doc.cuerpo.cc_id_518.splice(index, 1);
    this.model.doc.cuerpo.cc_id_519.splice(index, 1);
    this.model.doc.cuerpo.cc_id_520.splice(index, 1);
    this.model.doc.cuerpo.cc_id_521.splice(index, 1);
    this.model.doc.cuerpo.cc_id_522.splice(index, 1);
    this.model.doc.cuerpo.cc_id_523.splice(index, 1);
    this.model.doc.cuerpo.cc_id_524.splice(index, 1);
    this.model.doc.cuerpo.cc_id_525.splice(index, 1);
    this.model.doc.cuerpo.cc_id_526.splice(index, 1);
    this.model.doc.cuerpo.cc_id_527.splice(index, 1);
    this.model.doc.cuerpo.cc_id_528.splice(index, 1);


    //reenumerear it
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_508.length; i++) {


      this.model.doc.cuerpo.cc_id_508[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_509[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_510[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_514[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_515[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_516[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_517[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_518[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_519[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_520[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_521[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_522[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_523[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_524[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_525[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_526[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_527[i].it = i + 1;
      this.model.doc.cuerpo.cc_id_528[i].it = i + 1;


    }
  }

  public validateFormCompleted(): boolean {
    return (
      this.modelForm.ubicacionDelBien == undefined || this.modelForm.ubicacionDelBien == null || this.modelForm.ubicacionDelBien == '' ||
      this.modelForm.anioDeCompra == undefined || this.modelForm.anioDeCompra == null || this.modelForm.anioDeCompra == '' ||
      this.modelForm.valorDeCompra == undefined || this.modelForm.valorDeCompra == null || this.modelForm.valorDeCompra == '' ||
      this.modelForm.anioAnteriorAplicoReajusteArt73 == undefined || this.modelForm.anioAnteriorAplicoReajusteArt73 == null || this.modelForm.anioAnteriorAplicoReajusteArt73 == '' ||
      this.modelForm.valorDeclaradoAnioAnterior == undefined || this.modelForm.valorDeclaradoAnioAnterior == null || this.modelForm.valorDeclaradoAnioAnterior == '' ||
      this.modelForm.valorVenta == undefined || this.modelForm.valorVenta == null || this.modelForm.valorVenta == '' ||
      this.modelForm.mejoras == undefined || this.modelForm.mejoras == null || this.modelForm.mejoras == '' ||
      this.modelForm.avaluoCatastralAnioAnterior == undefined || this.modelForm.avaluoCatastralAnioAnterior == null || this.modelForm.avaluoCatastralAnioAnterior == '' ||
      this.modelForm.costoFiscal == undefined || this.modelForm.costoFiscal == null || this.modelForm.costoFiscal == '' || this.modelForm.costoFiscal == '0' ||
      this.modelForm.cumpleConLoSenaladoEnArt311 == undefined || this.modelForm.cumpleConLoSenaladoEnArt311 == null || this.modelForm.cumpleConLoSenaladoEnArt311 == '' ||
      this.modelForm.retencionOImpuestoExterior == undefined || this.modelForm.retencionOImpuestoExterior == null || this.modelForm.retencionOImpuestoExterior == '' ||
      this.modelForm.resultadoArt73MasMejoras == undefined || this.modelForm.resultadoArt73MasMejoras == null || this.modelForm.resultadoArt73MasMejoras == '' ||
      this.modelForm.avaluoCatastralMasMejoras == undefined || this.modelForm.avaluoCatastralMasMejoras == null || this.modelForm.avaluoCatastralMasMejoras == '' ||
      this.modelForm.valorDeclaradoAnioAnteriorMasMejoras == undefined || this.modelForm.valorDeclaradoAnioAnteriorMasMejoras == null || this.modelForm.valorDeclaradoAnioAnteriorMasMejoras == '' ||
      this.modelForm.valorDeCompraMasMejoras == undefined || this.modelForm.valorDeCompraMasMejoras == null || this.modelForm.valorDeCompraMasMejoras == '' ||
      this.modelForm.utilidad == undefined || this.modelForm.utilidad == null || this.modelForm.utilidad == '' ||
      this.modelForm.articulo44 == undefined || this.modelForm.articulo44 == null || this.modelForm.articulo44 == '' ||
      this.modelForm.articulo311 == undefined || this.modelForm.articulo311 == null || this.modelForm.articulo311 == ''

    );


  }

  public redondearFormData() {


    this.modelForm.valorDeCompra = this.dutilidades.redondearValorMoneda(this.modelForm.valorDeCompra, true)
    this.modelForm.valorDeclaradoAnioAnterior = this.dutilidades.redondearValorMoneda(this.modelForm.valorDeclaradoAnioAnterior, true)
    this.modelForm.valorVenta = this.dutilidades.redondearValorMoneda(this.modelForm.valorVenta, true)
    this.modelForm.mejoras = this.dutilidades.redondearValorMoneda(this.modelForm.mejoras, true)
    this.modelForm.avaluoCatastralAnioAnterior = this.dutilidades.redondearValorMoneda(this.modelForm.avaluoCatastralAnioAnterior, true)
    this.modelForm.costoFiscal = this.dutilidades.redondearValorMoneda(this.modelForm.costoFiscal, true)
    this.modelForm.retencionOImpuestoExterior = this.dutilidades.redondearValorMoneda(this.modelForm.retencionOImpuestoExterior, true)
    this.modelForm.resultadoArt73MasMejoras = this.dutilidades.redondearValorMoneda(this.modelForm.resultadoArt73MasMejoras, true)
    this.modelForm.avaluoCatastralMasMejoras = this.dutilidades.redondearValorMoneda(this.modelForm.avaluoCatastralMasMejoras, true)
    this.modelForm.valorDeclaradoAnioAnteriorMasMejoras = this.dutilidades.redondearValorMoneda(this.modelForm.valorDeclaradoAnioAnteriorMasMejoras, true)
    this.modelForm.valorDeCompraMasMejoras = this.dutilidades.redondearValorMoneda(this.modelForm.valorDeCompraMasMejoras, true)
    this.modelForm.utilidad = this.dutilidades.redondearValorMoneda(this.modelForm.utilidad, true)
    this.modelForm.articulo44 = this.dutilidades.redondearValorMoneda(this.modelForm.articulo44, true)
    this.modelForm.articulo311 = this.dutilidades.redondearValorMoneda(this.modelForm.articulo311, true)


  }

  changeCostoFiscal() {
      switch (this.selectCostoFiscal) {
        case 0: this.modelForm.costoFiscal = this.dutilidades.deshacerFormatoMoneda(this.modelForm.resultadoArt73MasMejoras);
  
          break;
        case 1: this.modelForm.costoFiscal = this.dutilidades.deshacerFormatoMoneda(this.modelForm.avaluoCatastralMasMejoras);
  
          break;
        case 2: this.modelForm.costoFiscal = this.dutilidades.deshacerFormatoMoneda(this.modelForm.valorDeclaradoAnioAnteriorMasMejoras);
  
          break;
        case 3: this.modelForm.costoFiscal = this.dutilidades.deshacerFormatoMoneda(this.modelForm.valorDeCompraMasMejoras);
  
          break;
  
        default:
          break;
      }
    
    this.modelForm.costoFiscal = Number(this.modelForm.costoFiscal).toString();
  }



  public calcularValoresForm(conservarArt?: boolean) {
    this.redondearFormData();
    //cálculo tabla art 44
    let valorArt44;
    let valor5000UVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, '5000', this.valorUVT.toString());
    if (this.modelForm.anioDeCompra > '1986') {
      valorArt44 = '0';
    }
    if (this.modelForm.anioDeCompra <= '1986' && this.modelForm.anioDeCompra >= '1977') {
      valorArt44 = this.tablaArt44[this.modelForm.anioDeCompra];
    }
    if (this.modelForm.anioDeCompra < '1977') {
      valorArt44 = '1';
    }
    // utilidad cas 522
    if (this.modelForm.valorVenta!=undefined) {
      if (this.model.doc.cuerpo.cc_id_509.length) {
        this.model.doc.cuerpo.cc_id_509[0] = {it:0,v:this.modelForm.valorVenta};
      }else{
        this.model.doc.cuerpo.cc_id_509.push({it:0,v:this.modelForm.valorVenta});
      }
    }

    
    this.modelForm.utilidad = '0';
    this.modelForm.utilidad = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.modelForm.valorVenta, this.modelForm.costoFiscal, true);
    if(Number(this.modelForm.utilidad)<0){
      this.modelForm.utilidad='0';
    }
    // art44 cas 523
    if (this.modelForm.anioDeCompra < '1987') {
      this.modelForm.articulo44 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.utilidad, valorArt44.toString(), true);
      //this.modelForm.articulo44 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.articulo44, this.modelForm.mejoras, true);
    } else {
      this.modelForm.articulo44 = '0';
    }


    // si cas 520 = 1; si cas 522>5000UVT; 5000UVT; si no cas 522
    // art311 cas 524
    if (this.modelForm.cumpleConLoSenaladoEnArt311 == '1') {

      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.modelForm.utilidad, valor5000UVT)) {

        this.modelForm.articulo311 = valor5000UVT;
      } else {
        // this.modelForm.articulo311 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.utilidad, valor5000UVT, true);
        // this.modelForm.articulo311 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.articulo311, this.modelForm.mejoras, true);
        this.modelForm.articulo311 = this.modelForm.utilidad;
      }
    } else {
      this.modelForm.articulo311 = '0';
    }


    //avaluo catastral mas mejoras 526
    this.modelForm.avaluoCatastralMasMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.avaluoCatastralAnioAnterior, this.modelForm.mejoras, true);
    //valor declarado año anterior mas mejoras cas 527
    this.modelForm.valorDeclaradoAnioAnteriorMasMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.valorDeclaradoAnioAnterior, this.modelForm.mejoras, true);

    //valor de compra mas mejoras cas 528
    this.modelForm.valorDeCompraMasMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.valorDeCompra, this.modelForm.mejoras, true);


    //art 73 mas mejoras casilla 525
    this.resultadoArticulo73 = this.tablaArt73
      .filter(item => item.anioGravable === "2023" && item.anio == this.modelForm.anioDeCompra)
      .map(item => item.bienes);
    this.modelForm.resultadoArt73MasMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valorDeCompra, this.resultadoArticulo73[0], true);
    this.modelForm.resultadoArt73MasMejoras = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelForm.resultadoArt73MasMejoras, this.modelForm.mejoras, true);




    this.reloadSelArticulos(conservarArt);
  }


  saveItem(): void {
    if (this.validateFormCompleted()) {
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro");
      return;
    } else {
      this.redondearFormData();
      if (this.operacionTabla == this.OPERACION_EDITAR) {
        this.dataSourceBody.forEach((el) => {
          if (el.id == this.modelForm.id) {
            el = this.modelForm;
          }
        });
      } else if (this.operacionTabla == this.OPERACION_AGREGAR && this.dataSourceBody.length < 1) {
        this.modelForm.id = this.dataSourceBody.length;
        // this.modelForm.textoUbicacionDelBien = this.lstUbicacionVivienda[Number(this.modelForm.ubicacionDelBien)-1].nombre;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCC509_0();
      this.inicializeForm();
      this.operacionTabla = this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if ($event === 'add') this.operacionTabla = this.OPERACION_AGREGAR;
    if ($event === 'edit') this.operacionTabla = this.OPERACION_EDITAR;
    if ($event === 'delete') this.operacionTabla = this.OPERACION_BORRAR;
    this.operacionCC509_0();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if (this.operacionTabla == this.OPERACION_EDITAR) {//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if (this.operacionTabla == this.OPERACION_BORRAR) {//borrando
      //this.deleteOnModel(index);
      this.operacionTabla = this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla = this.OPERACION_NULA;
  }



  public operaciones(numCas?: number, soloEstaCasilla?: boolean): void {
    switch (numCas) {
      case 152:
        this.operacionCC509_0();
        break;
    }
    if (soloEstaCasilla) return;

    //Operaciones
    let resultado = "0";

    //C151=C149-C153+C154+C155; 
    resultado = "0";
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.model.doc.cuerpo.cs_id_149, this.model.doc.cuerpo.cs_id_153, true);
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado, this.model.doc.cuerpo.cs_id_154, true);
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado, this.model.doc.cuerpo.cs_id_155, true);
    resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0") ? "0" : resultado;
    this.model.doc.cuerpo.cs_id_151 = this.dutilidades.redondearValorMoneda(resultado, true);

  }

  operacionCC509_0() {
    if(this.model.doc.cuerpo.cc_id_509.length>0){
      this.model.doc.cuerpo.cs_id_509 = this.model.doc.cuerpo.cc_id_509[0] != undefined ? this.model.doc.cuerpo.cc_id_509[0].v : "0";
    }
  } 
  protected obtenerCasIndicadorAvance(): string {
    if (this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] == undefined) {
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE] = "0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }



  protected controlStep(direction: DirectionType): void {

  }



  public closeModal() {
    this.initializeTablaDesdeModelo();
    this.operacionCC509_0();
    //this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar() {

    //Limpiar modelo y agregar el contenido de la tabla
    this.model.doc.cuerpo.cc_id_508 = undefined;
    this.inicializeModelo();
    for (let i = 0; i < this.dataSourceBody.length; i++) {
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCC509_0();
    const componentBeneficiosDescuentos = this._componentFactory.createModalComponent(BeneficiosTributariosDescuentosModalComponent, this.model);
    componentBeneficiosDescuentos.instance.inicializeModelo();
    componentBeneficiosDescuentos.instance.actualizarDataVenVivi();

    const componentIngAsalariadoServPub = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
    componentIngAsalariadoServPub.instance.initializeTablaDesdeModelo();
    componentIngAsalariadoServPub.instance.operacionesLimitantesComunes();


    const componentIngresosTrabInd = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
    componentIngresosTrabInd.instance.initializeTablaDesdeModelo();
    for (let i = 0; i < this.model.doc.cuerpo.cc_id_309.length; i++) {
      componentIngresosTrabInd.instance.operacionCs319(i);
      componentIngresosTrabInd.instance.operacionCs320(i);
      componentIngresosTrabInd.instance.operacionCs321(i);
      componentIngresosTrabInd.instance.operacionCs307(i);
    }



    const componentBenIngNoRenta = this._componentFactory.createModalComponent(BeneficiosIngresosNoGravados, { model: this.model });

    componentBenIngNoRenta.instance.uvt = this.valorUVT; //sokuciona uvt quemada $42412
    componentBenIngNoRenta.instance.reset();
    componentBenIngNoRenta.instance.initializeTablaDesdeModelo();
    componentBenIngNoRenta.instance.operacionCS691();
    componentBenIngNoRenta.instance.operacionCS676();
    componentBenIngNoRenta.instance.guardar();

    console.log(this.model.doc.cuerpo.cs_id_691)
    const componentIngTrabIndependiente = this._componentFactory.createModalComponent(IngresostrabajadorindependienteModalComponent, { model: this.model });
    componentIngTrabIndependiente.instance.initializeTablaDesdeModelo();
    componentIngTrabIndependiente.instance.operacionTotalizarCasillasOcultas();//las dependiencias son en casillas ocultas, no en total


    const componentAsalariado = this._componentFactory.createModalComponent(IngresosAsalariadooServidorpublicoModalComponent, { model: this.model });
    componentAsalariado.instance.uvt = this.valorUVT; //Soluciona uvt quemada $42412
    componentAsalariado.instance.initializeTablaDesdeModelo();
    componentAsalariado.instance.operacionCs280();


    this.saveModel.emit(true);
    this.closeModal();

  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ingresos/ingresos-venta-vivienda-modal/ingresos-venta-vivienda-modal.component.ts